import fromPairs from 'lodash/fromPairs.js';
import differenceWith from 'lodash/differenceWith.js';
import toPairs from 'lodash/toPairs.js';
import isEqual from 'lodash/isEqual.js';

function convertToUnit(str) {
  let unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';
  if (str == null || str === '') {
    return undefined;
  }
  if (isNaN(str)) {
    return String(str);
  }
  return `${Number(str)}${unit}`;
}
function cached(fn) {
  const cache = Object.create(null);
  return function cachedFn(str) {
    const hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
}
const capitalize = cached(str => {
  return str.charAt(0).toUpperCase() + str.slice(1);
});
function isWhitespace(node) {
  return node.isComment && !node.asyncFactory || node.text === ' ';
}
function hasSlot(vm) {
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  let data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const scopedSlotFn = vm.$scopedSlots[name];
  let nodes;
  if (scopedSlotFn) {
    nodes = scopedSlotFn(data);
  } else {
    nodes = vm.$slots[name];
  }
  if (Array.isArray(nodes)) {
    return nodes.some(node => !isWhitespace(node));
  }
  return false;
}
const keyCodes = {
  backspace: 8,
  enter: 13,
  esc: 27,
  space: 32,
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  delete: 46,
  shift: 16,
  ctrl: 17,
  tab: 9,
  pageUp: 33,
  pageDown: 34
};
function getShallowObjectDiff(newValue, oldValue) {
  return fromPairs(differenceWith(toPairs(oldValue), toPairs(newValue), isEqual));
}
function clamp(val, min, max) {
  if (val > max) {
    return max;
  }
  if (val < min) {
    return min;
  }
  return val;
}
function iconTypeToGeneric(type) {
  const iconMapping = {
    'alert-circle': 'alert',
    'alert-circle-solid': 'alert',
    'alert-octagon': 'alert',
    'alert-triangle': 'alert',
    'arrow-down-circle': 'arrow-down',
    'arrow-left-circle': 'arrow-left',
    'arrow-right-circle': 'arrow-right',
    'arrow-up-circle': 'arrow-up',
    'bar-chart-2': 'bar-chart',
    'chart-area-stacked': 'chart-area',
    'chart-area-stacked-relative': 'chart-area',
    'chart-bar-stacked': 'chart-bar',
    'chart-bar-stacked-relative': 'chart-bar',
    'chart-column-stacked': 'chart-column',
    'chart-column-stacked-relative': 'chart-column',
    'check-circle': 'check',
    'check-circle-2': 'check',
    'check-circle-2-solid': 'check',
    'check-square': 'check',
    'chevron-down-square': 'chevron-down',
    'divide-square': 'divide',
    'divide-circle': 'divide',
    'draggable-horizontal': 'draggable',
    'draggable-vertical': 'draggable',
    'edit-2': 'edit',
    'edit-3': 'edit',
    'help-circle': 'help',
    'info-solid': 'info',
    'link-2': 'link',
    'maximize-2': 'maximize',
    'message-circle': 'message',
    'message-square': 'message',
    'minimize-2': 'minimize',
    'minus-circle': 'minus',
    'minus-circle-solid': 'minus',
    'minus-square': 'minus',
    'more-horizontal': 'more',
    'more-vertical': 'more',
    'navigation-2': 'navigation',
    'play-circle': 'play',
    'plus-cricle': 'plus',
    'plus-square': 'plus',
    'refresh-ccw': 'refresh-counter-clockwise',
    'refresh-cw': 'refresh-clockwise',
    'roadmaps-backlog-solid': 'roadmaps-backlog',
    'rocket-2': 'rocket',
    'rotate-ccw': 'rotate-counter-clockwise',
    'rotate-cw': 'rotate-clockwise',
    'share-2': 'share',
    'stop-circle': 'stop',
    'trash-2': 'trash',
    'x-circle': 'x',
    'x-octagon': 'x',
    'x-square': 'x'
  };
  return iconMapping[type] || type;
}

export { cached, capitalize, clamp, convertToUnit, getShallowObjectDiff, hasSlot, iconTypeToGeneric, isWhitespace, keyCodes };
//# sourceMappingURL=utils.js.map
